"use client";
import { type Translationtype } from "utils";

interface ISubmitButtonProps {
  t: Translationtype;
  text?: string;
  disabled?: boolean;
  showLoader?: boolean;
  className?: string;
  extraClassName?: string;
}
export function FormSubmitButton({
  t,
  text,
  disabled,
  showLoader,
  className,
  extraClassName,
}: ISubmitButtonProps) {
  return (
    <button
      type="submit"
      disabled={disabled}
      className={`btn ${className || ""} ${
        disabled || showLoader
          ? "btn-disabled"
          : extraClassName || "btn-primary"
      } `}
    >
      <div className="flex flex-row items-center gap-2">
        {showLoader ? <span className="loading loading-spinner" /> : null}
        <span className="block">{t(text || ("Buttons.next" as any))}</span>
      </div>
    </button>
  );
}
